import { jsx as _jsx } from "react/jsx-runtime";
import { renderToString } from "react-dom/server";
import { PinStoreActiveIcon } from "@jti/brand-icons/pin-store-active";
import { PinStoreDefaultIcon } from "@jti/brand-icons/pin-store-default";
import { PinStoreNegativeIcon } from "@jti/brand-icons/pin-store-negative";
import { UiTargetIcon } from "@jti/brand-icons/ui-target";
const svgDataURIHeader = "data:image/svg+xml;charset=utf-8,";
export const createImageIcon = (icon) => {
    return svgDataURIHeader + encodeURIComponent(icon);
};
export const USER_LOCATION = createImageIcon(renderToString(_jsx(UiTargetIcon, { width: 43, height: 43, fill: "#3567FF" })));
export const DEFAULT_MARKER = createImageIcon(renderToString(_jsx(PinStoreDefaultIcon, { width: 30, height: 30 })));
export const DEFAULT_MARKER_NAVER = createImageIcon(renderToString(_jsx(PinStoreNegativeIcon, { width: 30, height: 30 })));
export const ACTIVE_MARKER = createImageIcon(renderToString(_jsx(PinStoreActiveIcon, { width: 30, height: 30 })));
//# sourceMappingURL=store-locator-icons.js.map